import Login from "../../components/user/Login";
import LoginAggr from '../../components/user/LoginAggr';
export default {
  components: {
    Login: Login,
    LoginAggr: LoginAggr
  },
  data: function data() {
    return {
      type: 'normal'
    };
  },
  created: function created() {
    this.type = this.$route.query.type;
    console.log("login type", this.type);
  },
  methods: {}
};